var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 47,
    viewBox: "0 0 38 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 34.2333C36.9611 36.5351 36.4645 37.5607 35.1265 39.5943C33.2624 42.4339 30.632 45.9706 27.3724 46C24.4767 46.0266 23.7326 44.1168 19.8025 44.1389C15.8724 44.161 15.0531 46.0354 12.1574 46.0074C8.89782 45.9779 6.40743 42.7846 4.54185 39.9435C-0.674701 32.0038 -1.21993 22.6847 1.99694 17.7319C4.28397 14.21 7.89135 12.1514 11.2836 12.1514C14.7362 12.1514 16.9083 14.045 19.7642 14.045C22.5345 14.045 24.2218 12.1484 28.2153 12.1484C31.2332 12.1484 34.4309 13.7915 36.7106 16.6311C29.2453 20.7233 30.4581 31.3819 38 34.2333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6092 7.17645C27.0607 5.31529 28.1615 2.68638 27.7606 0C25.3911 0.162096 22.6207 1.66959 21.0012 3.63538C19.532 5.41844 18.3193 8.06355 18.7908 10.635C21.377 10.716 24.0545 9.1717 25.6092 7.17645Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.1e261c37e16350ad109238f35004f3e3.svg";
export { ForwardRef as ReactComponent };